(function () {
    'use strict';

    jcu_js_v1.fn.tooltips = {};
    jcu_js_v1.fn.tooltips.initTooltips = function () {
        var tooltips = document.querySelectorAll('[data-tooltip-text]');

        tooltips.forEach(function (element, key) {

            jcu_js_v1.fn.tooltips.renderTooltip(element);

        });
    }

    jcu_js_v1.fn.tooltips.renderTooltip = function (element) {

        // Create tooltip container
        var container = document.createElement('div');
        var tooltipDataSize = element.getAttribute('data-tooltip-size');
        if(tooltipDataSize=="large"){
            container.className = 'tooltip tooltip--large';
        }else{
            container.className = 'tooltip';
        }
        
        container.setAttribute('aria-hidden', 'true');
        container.style.height = element.offsetHeight + 'px';

        if (element.getAttribute('data-tooltip-mobile') === 'false') {
            container.classList.add('tooltip--desktop');
        }

        // Add screen reader text
        jcu_js_v1.fn.tooltips.addScreenReaderText(element, container);

        // Render Tooltip bubble and append to container
        var tooltipBubble = jcu_js_v1.fn.tooltips.renderTooltipBubble(element);
        container.appendChild(tooltipBubble);        

        // Add tooltip container before target element
        element.parentNode.insertBefore(container, element);

        // Keep tooltip within available window area
        jcu_js_v1.fn.tooltips.updateTooltipPosition(element, container, tooltipBubble);

        // Initialise hover and focus events
        jcu_js_v1.fn.tooltips.initTooltipEvents(element, container);
    }

    // Add screen reader text
    jcu_js_v1.fn.tooltips.addScreenReaderText = function (element, container) {
        var tooltipDataText = element.getAttribute('data-tooltip-text');
        element.setAttribute('aria-label', tooltipDataText);
    }

    // Create tooltip bubble
    jcu_js_v1.fn.tooltips.renderTooltipBubble = function (element) {

        // Vars
        var tooltipDataText = element.getAttribute('data-tooltip-text');
        var tooltipDataVertOffset = element.getAttribute('data-tooltip-offset');
        var tooltipDataImage = element.getAttribute('data-tooltip-image');
        var tooltipDataImageAlt = element.getAttribute('data-tooltip-image-alt');
        

        // Add tooltip bubble div
        var tooltipBubble = document.createElement('div');
        tooltipBubble.className = 'tooltip__bubble';
        
        tooltipBubble.setAttribute('hidden', 'hidden');
        tooltipBubble.innerHTML = '<span class="tooltip__triangle">'

        // Add tooltip bubble vertical offset
        if (tooltipDataVertOffset !== null) {
            var elementHeight = element.offsetHeight;
            tooltipBubble.style.bottom = (elementHeight + Number(tooltipDataVertOffset)) + 'px';
        }

        // Add tooltip bubble content
        var tooltipContent = document.createElement('div');
        tooltipContent.className = 'tooltip__content';

        // Add tooltip bubble image
        if (tooltipDataImage !== null) {
            var tooltipImage = document.createElement('img');
            tooltipImage.className = 'tooltip__img';
            tooltipImage.setAttribute('src', tooltipDataImage);
            tooltipImage.setAttribute('alt', tooltipDataImageAlt);
            tooltipContent.appendChild(tooltipImage);
        }

        // Add tooltip bubble text
        var tooltipText = document.createElement('span');
        tooltipText.className = 'tooltip__text';
        tooltipText.innerHTML = tooltipDataText;

        tooltipContent.appendChild(tooltipText);


        tooltipBubble.appendChild(tooltipContent);

        return tooltipBubble;
    }

    // Ensure tooltip does not extend outside window
    jcu_js_v1.fn.tooltips.updateTooltipPosition = function (element, container, tooltipBubble) {

        // Remove pull classes
        tooltipBubble.classList.remove('tooltip--pull-right');
        tooltipBubble.classList.remove('tooltip--pull-left');

        // Anchor tooltip to center of element
        var centerX = element.offsetLeft + element.offsetWidth / 2;
        container.style.left = (centerX) + 'px';

        // Shift anchor right or left
        var tooltipDataPosition = element.getAttribute('data-tooltip-position');
        if (tooltipDataPosition !== null) {
            var offset = 0.3 * element.offsetWidth;

            if (tooltipDataPosition === 'left') {
                container.style.left = (centerX - offset) + 'px';
            } else if (tooltipDataPosition === 'right') {
                container.style.left = (centerX + offset) + 'px';
            }
        }

        // Detect page edge and add pull classes
        var distanceToLeftEdge = tooltipBubble.getBoundingClientRect().left;
        var distanceToRightEdge = window.innerWidth - tooltipBubble.getBoundingClientRect().right;

        if (distanceToRightEdge < 30) {
            tooltipBubble.classList.add('tooltip--pull-left');
        }

        else if (distanceToLeftEdge < 30) {
            tooltipBubble.classList.add('tooltip--pull-right');
        }
    }

    jcu_js_v1.fn.tooltips.initTooltipEvents = function (element, container) {

        var hover = false;
        var focus = false;

        element.addEventListener('focusin', function () {
            focus = true;
            jcu_js_v1.fn.tooltips.showTooltip(element, container);
        });

        element.addEventListener('focusout', function () {
            focus = false;

            if (!hover) {
                jcu_js_v1.fn.tooltips.hideTooltip(element, container);
            }
        });

        element.addEventListener('mouseenter', function () {
            hover = true;
            jcu_js_v1.fn.tooltips.showTooltip(element, container);
        });

        element.addEventListener('mouseleave', function () {
            hover = false;

            if (!focus) {
                jcu_js_v1.fn.tooltips.hideTooltip(element, container);
            }
        })

        element.addEventListener('keyup', function (e) {
            if (e.keyCode === 27) {
                jcu_js_v1.fn.tooltips.hideTooltip(element, container);
            }
        });

    }

    jcu_js_v1.fn.tooltips.showTooltip = function (element, container) {
        var tooltipBubble = container.querySelector('.tooltip__bubble');
        tooltipBubble.removeAttribute('hidden');
        jcu_js_v1.fn.tooltips.updateTooltipPosition(element, container, tooltipBubble);
    }

    jcu_js_v1.fn.tooltips.hideTooltip = function (element, container) {
        var tooltipBubble = container.querySelector('.tooltip__bubble');
        tooltipBubble.setAttribute('hidden', true);
    }

    jcu_js_v1.fn.tooltips.initTooltips();

}());
